<template>
    <div>
        <div class="container-fluid white-bg centers-list">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / <a href="/home-teacher/onlineteacher">ONLINETeacher</a> /
                          German for Beginners
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h1 class="strongh1">German for Beginners. Немецкий для начинающих</h1>
                        <p class="px18">Курс групповых онлайн-занятий по программе «German for Beginners» рассчитан на детей от 3 до 8 лет, не имеющих опыта изучения немецкого. Хотите, чтобы ваш малыш играючи освоил один из самых востребованных европейских языков? Тогда этот курс для вас!</p>

                      <p class="px18"><span class="strong-black">Пройдя обучение, ребёнок узнает <span class="strong-red">150 слов</span> на новом языке, научится понимать немецкую речь и без стеснения отвечать на вопросы преподавателя.</span>
                        </p>


                        <p>&nbsp;</p>
                        <h3 class="redh3" style="text-align: center; margin-bottom: 30px;">Вместе мы изучим:</h3>

                      <div class="indivurok"><div class="urk">Продукты питания и напитки</div></div>
                      <div class="indivurok"><div class="urk">Погоду</div></div>
                      <div class="indivurok"><div class="urk">Животных</div></div>
                      <div class="indivurok"><div class="urk">Описание людей</div></div>
                      <div class="indivurok"><div class="urk">Цифры и счёт</div></div>
                      <div class="indivurok"><div class="urk">Времена года и месяцы</div></div>
                      <div class="indivurok"><div class="urk">Части тела</div></div>
                      <div class="indivurok"><div class="urk">Профессии</div></div>
                      <div class="indivurok"><div class="urk">Цвета</div></div>
                    </div>
                </div>
            </div>
        </div>
      <!--
      <div class="container-fluid white-bg centers-list razuchim no-shadow">
        <div class="container align-middle">
          <div class="row">
            <div class="col-12">
              <div class="skill-wrapper">
                <div class="skill-text skill-text-1"><span>Продукты питания и напитки</span></div>
                <div class="skill-text skill-text-2"><span>Погоду</span></div>
                <div class="skill-text skill-text-3"><span>Животных</span></div>
                <div class="skill-text skill-text-4"><span>Описание людей</span></div>
                <div class="skill-text skill-text-5"><span>Цифры и счёт</span></div>
                <div class="skill-text skill-text-6"><span>Времена года и месяцы</span></div>
                <div class="skill-text skill-text-7"><span>Части тела</span></div>
                <div class="skill-text skill-text-8"><span>Профессии</span></div>
                <div class="skill-text skill-text-9"><span>Цвета</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->

        <div class="container-fluid white-bg centers-list no-shadow">
            <div class="container align-middle">
                <div class="row" style="margin-top: 20px;">
                    <div class="col-12">
                        <p class="px18">Обучение проходит в формате игры, без спешки и напряжения. Дети с радостью узнают немецкие названия привычных вещей и спешат поделиться с родными новыми знаниями!</p>
                        <p class="px18">Уроки на платформе OnlineTeacher проводятся профессиональными педагогами в режиме реального времени. Мы обучаем через Интернет, а значит, ваш ребёнок может заниматься где угодно: дома, в машине и даже на даче при помощи обычного смартфона, или планшета. Всё, что вам потребуется, это устойчивая связь (от 1 Mбит/с) и хороший микрофон.</p>
                        <p class="px18"><span class="strong-black">Для вашего ребёнка занятия на платформе OnlineTeacher &ndash; это отличная возможность весело провести время, пообщаться с другими детьми и получить бесценные знания. Присоединяйтесь к нашей дружной компании!</span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                src="https://www.poliglotiki.ru/embed/42MC62cDy00" frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <TimetableStatic id="7286"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="redh2">Всё о курсе</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-12">

                      <p class="px18">Программа курса <span class="strong-green">«German for Beginners»</span> разрабатывалась методистами сети Полиглотики с учётом недавних открытий в области нейропедагогики. Цикл занятий выстроен таким образом, что ваш ребёнок может приступить к обучению в любой момент. Вам не нужно догонять группу &ndash; просто начните заниматься!
                        </p>
                      <p class="px18"><span class="strong-black">Уроки в нашей онлайн-школе проходят по расписанию <span class="strong-red">2</span> раза в неделю. Мы позаботились о том, чтобы ваш ребёнок не переутомлялся: занятия длятся не более </span>
                            <span class="strong-red">45 минут</span> <span class="strong-black">, включая обязательную разминку, гимнастику для глаз и время для обратной связи. В конце занятия у вас есть</span>&nbsp;<span
                                    class="strong-red">5 минут</span>&nbsp;<span class="strong-black">для того, чтобы обсудить с преподавателем успехи ребёнка и получить рекомендации по самостоятельной работе. Для достижения нужного результата рекомендуем вам посещать все занятия, не пропуская.</span></p>
                        <p class="px18">Наши уроки немецкого языка очень нравятся детям. Малыши 4-5 лет быстро привыкают к формату занятий и в дальнейшем могут изучать иностранный язык без помощи родителей. Вы можете смело доверить ребёнка заботе нашего педагога: используя смену различных интересных занятий в ходе урока она мастерски удерживает внимание даже самых маленьких детей.</p>
                    </div>

                </div>
                <!-- <div class="row">
                    <div class="col-12">
                        <CourseStatic id="34"/>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="container-fluid blue-wave-top" style="margin-top: -7px;"></div>
        <div class="container-fluid grey-bg no-shadow" style="text-align:left;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="land-t-h2" style="margin-bottom: 40px; text-align: center;">Наш преподаватель</h2>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-3 centers-text">

                    </div>
                    <div class="col-12 col-sm-6 centers-text">
                        <a href=""><img src="@/assets/hometeacher/images/koshheeva.jpg" alt="Анастасия Кощеева" class="teacher-krug"></a>
                        <div class="teacher-name"><a href="">Анастасия Кощеева</a></div>
                        <div class="speach">Привет! Я преподаватель немецкого языка, закончила лингвистический университет в Нижнем Новгороде по направлению "Немецкий и английский перевод". Имею опыт преподавания немецкого языка как в России, так и зарубежом. Буду рада поделиться своими знаниями с ребятами, так как немецкий язык с каждым годом становится все более популярным.
                        </div>
                    </div>
                    <div class="col-12 col-sm-3 centers-text">

                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 40px;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="redh2">Как проходят наши уроки</h2>
                        <p class="px18">Онлайн-занятия от Полиглотиков основаны на коммуникативном подходе, эффективность которого доказана многолетней практикой. Обучение происходит только в процессе общения детей с педагогом, игр, создания поделок, демонстрации предметов и изображений. Мы против нудной зубрёжки: изучать немецкий язык можно легко и весело, без стрессов и напряжения!</p>
                        <p class="px18"><span class="strong-black">Уроки ведутся по принципу: «One person – one language». Это означает, что на занятиях педагог общается с детьми только на немецком языке, не переходя на русский. Таким образом, ребёнок с первого занятия погружается в новую языковую среду и быстро учится в ней ориентироваться. Догадаться о смысле высказываний преподавателя ему помогает выразительная мимика, жесты и иллюстрации, которыми сопровождается урок.</span>
                        </p>
                        <p class="px18">Наша методика позволяет усваивать новые слова и грамматические конструкции на интуитивном уровне, как в раннем детстве, когда мы изучаем родной язык. Можно сказать, что на занятиях у ребёнка постепенно формируется билингвизм &ndash; достаточно редкое явление в обычных условиях. Через некоторое время ученик начинает не только говорить, но и думать по-немецки.</p>
                        <p class="px18"><span class="strong-black">Секрет успеха наших занятий очень прост: следуя законам нейропедагогики,имы  активно вовлекаем правое полушарие мозга в процесс освоения иностранного языка. Известно, что правое полушарие отвечает за образы и эмоции, в то время, как левое — за логику и факты. Традиционные методики практически не используют возможности правого полушария. Вот почему изучать иностранный язык в школе так скучно и трудно. К счастью, на наших занятиях всё по-другому!</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid blue-wave-top" style="margin-top: -7px;"></div>
        <div class="container-fluid blueback about-fr" style="text-align:left;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="greenh2">Чтобы дети легко запоминали новые слова, наш педагог:</h2>

                    </div>
                </div>
                <div class="row bird-pres">
                    <div class="col-12 col-sm-3">
                        <img class="" src="@/assets/hometeacher/images/birdushka.png">
                        <p style="margin-top: 25px;">Рисует вместе с ними</p>
                    </div>

                  <div class="col-12 col-sm-3">
                    <img class="" src="@/assets/hometeacher/images/bird-8.png">
                    <p style="margin-top: 25px;">Поёт им песенки</p>
                  </div>
                  <div class="col-12 col-sm-3">
                    <img class="" src="@/assets/hometeacher/images/garant-img-8.png">
                    <p style="margin-top: 25px;">Проходит с ними забавные тесты</p>
                  </div>

                    <div class="col-12 col-sm-3">
                        <img class="" src="@/assets/hometeacher/images/garant-img-5.png">

                        <p>Включает мультфильмы на немецком языке.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page" style="padding-top: 40px;">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <p class="px18">Уроки проходят в тёплой позитивной атмосфере. Педагоги давно заметили: чем спокойнее обстановка, тем охотнее дети занимаются, тем легче запоминают новую информацию. Наш преподаватель обращается с учениками очень бережно, поощряя их в них тягу к новым знаниям. Очень важно, чтобы и родители поддерживали ребёнка. Не нужно ругать его, если он делает ошибки, или плохо запоминает слова — в начале обучения это совершенно естественно.</p>
                        <p class="px18"><span class="strong-black">Помните, прогресс придёт со временем, ведь наша методика предусматривает постепенное накопление языковых знаний без стресса и напряжения. Наберитесь терпения, доверьтесь мастерству нашего педагога и результат не заставит себя ждать!</span></p>


                        <h3 class="redh3" style="text-align: center;">Быть Полиглотиком просто: запишитесь на занятия прямо сейчас и маленькими шагами двигайтесь к большой цели вместе с нами!</h3>
                    </div>
                </div>

                <div class="row about-center">
                    <div class="col-12" style="padding-top: 40px;">
                        <a href="/home-teacher/subscription/order/1/7286" class="knpk">Записаться на курс</a>
                        <p>&nbsp;</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-top: 30px;"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2><span class="strong-black">Отзывы об онлайн-уроках</span></h2>
                        <p>&nbsp;</p>
                    </div>
                </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nataliya-yuferova.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">24.05.2021</span>
                  <span class="nameotzyv">Наталия Юферова <a href="https://vk.com/id4037847" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года. Дочке было 5 лет, ранее знакомства с английским языком не было. На Полиглотиков наткнулась случайно: заинтересовал он-лайн формат обучения при многообразии уроков. Я всегда за обучение в формате игр, а тут и music class, и story time, и art class. На первый урок попали к Виктории, с нами были ещё несколько ребят, которые уже ориентировались в английском. Хочу сразу сказать огромное спасибо преподавателям за их чуткость к детям, заинтересованность в их обучении, благожелательность, жизнерадостность и внимание! Спасибо за то, что прививаете любовь к языкам нашим детям! Сразу скажу, что дочка первые занятия не понимала и не запоминала слова, но была увлечена, с нетерпением ждала уроков, и правильный ответ для неё был маленькой победой! Мне в свою очередь было очень удобно он-лайн обучение: мы были на дистанционной работе, а ребёнка можно было просто посадить рядом и подсказывать при необходимости. Сейчас это также удобно, потому что если мы не успеваем, то подключиться к уроку дочка может или сама, или бабушка поможет, не нужно никуда собираться и ехать. А иногда я занимаюсь домашними делами, а ребёнок рядом занимается. При этом мы, родители, знаем, что дети проходят, можем помочь, повторить слова, вводить их в повседневный разговор, скачать изучаемые песни, чтобы вместе попеть, почитать книжку на русском, ту, которую читали на английском на уроках (это просто огромный плюс). А ещё дети неохотно отрываются от своих игр и маленьких дел даже ради любимых занятий, а тут можно даже игрушки не убирать, просто переместиться за стол, а по окончании вернуться в игру. По самим урокам: мне нравится наполненность, дозированность информации в сочетании с переменками в виде песенок с движениями-дети не успевают ни заскучать, ни устать. Поделки с art класса мы носили в садик, дарили в виде новогодних подарков родственникам - темы поделок всегда актуальны. Ещё раз спасибо всем нашим преподавателям! И за обратную связь! Как результат занятий - дочка может пройти этап знакомства, ответить на вопросы о любимых игрушках/блюдах/цветах, рассказать о погоде и описать человека, а ещё спеть пару песенок на английском, но под фонограмму :))) и выдать слова, которые мы вроде не проходили, но встречали на уроках story time. Надеюсь, что дальше будет только увлекательнее и интереснее.</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nadya-brandaus.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">21.05.2021</span>
                  <span class="nameotzyv">Nadya Brandaus <a href="https://vk.com/id294529857" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника. Для меня удивительно, почти час ребёнок погружен в процесс, слушает и отвечает с удовольствием. Преподаватели - просто волшебники! Моя дочь очень застенчива, легко отвлекается, до этого мы пробовали несколько курсов, где не получалось. «Полиглотики» придали ребёнку самоуверенности. Дочка выучила много новых слов и выражений, стала разговаривать и напевать на английском. Мы очень рады, что нашли вас! Удачи всем!</span>

                </div>
              </div>

              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/no-avatar-1.png"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">20.05.2021</span>
                  <span class="nameotzyv">Olia Foro <a href="https://vk.com/o.foro" target="_blank">vk.com</a></span><br>

                  <span class="textotzyv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ, но у ребенка пропадал интерес после нескольких уроков. Но попав в эту школу, мы остаёмся тут на долго. Прекрасные преподаватели, которые умеют увлечь маленьких непосед, служба поддержки, которая всегда на связи и оперативно отвечает на все запросы, огромное количество различных занятий. Ребенок с нетерпением ждет каждого урока, всегда есть обратная связь, групповые занятия проходят очень весело и продуктивно. Всегда учитываются пожелания клиента. Очень рады быть с Вами!!!</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/vera-kondrateva.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">18.05.2021</span>
                  <span class="nameotzyv">Вера Кондратьева <a href="https://www.facebook.com/profile.php?id=100008304612517" target="_blank">facebook.com</a></span><br>

                  <span class="textotzyv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей, ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу https://poliglotiki.com для изучения англ языка.<br>
                      Уроки проходят с понедельника по субботу 2 раза в день, группы представлены разные от 3 до 17 лет, причем мы живем в Доминикане и по нашему часовому поясу занятия также проходят в 10,11.12,13 по местному, т.е. вечером по Москве. Занятия классные, в игровой форме, для начинающих деток проходит обучение в форме игры, занятий по рисованию, чтение сказок, поем песенки и ВСЕ на англ. Для нас это выход, ребенок общается с другими детьми, постоянно слушает англ речь. Цены не просто доступные, а супердоступные. Первые 3 дня бесплатно, смотрите, пробуете. Мы намучались выбирая разные платформы и способы обучения, многие просто берут неадекватные деньги за те же самые услуги, устраивает все от качества,формы преподования, до цены и внеурочного общения с менеджерами. Это лучшая платформа, что мы встречали по изучению англ языка, там есть и другие языки, но мы пока учим англ. Хотела поделиться с теми, кто также как мы давно ищет нечто подобное и не может найти, я как мать двоих детей, обучающая своих детей дома, понимаю и знаю как это тяжело, поэтому решила сделать здесь пост, кому то надеюсь очень поможет, а вы когда нибудь поделитесь тоже чем то интересным и так общими усилиями будем помогать друг друг в этом нелегком дете воспитания наших деток. Я не менеджер ответов на вопросы не даю, если есть вопросы пишите им лично, сайт я указала. Всем хорошего дня!!</span>

                </div>
              </div>
              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">27.02.2021</span>
                  <span class="nameotzyv">Елена Серебрякова <a href="https://vk.com/id426090428" target="_blank"
                                                               rel="nofollow">vk.com</a></span><br>

                  <span class="textotzyv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского. Дети всегда могут обратиться и на русском, и на английском языках. В занятиях красочные задания, песни; преподаватели всегда интересуются качеством связи, чтобы слышать всех учеников. Поправляют ошибки вежливо, без придирок, всегда обращают внимание на правильность произношения. Занятий много в расписании, можно посещать любые. Преподаватели знакомятся с каждым ребенком, нет чувства, что занимаешься с чужим человеком. К каждой теме, есть тематическая песня. На музыкальных занятиях изучают песни, по строчкам проговаривая текст.</span>
                </div>
              </div>

              <div class="row mention justify-content-center">
                <div class="col-12 col-sm-2 m-photo">
                  <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                                     src="@/assets/hometeacher/images/marina-fedorina.jpg"></a>
                </div>
                <div class="col-12 col-sm-10 home-mention">
                  <span class="dateotzyv">22.01.2021</span>
                  <span class="nameotzyv">Марина Федорина <a href="https://vk.com/id42068522" target="_blank"
                                                             rel="nofollow">vk.com</a></span><br>

                  <span class="textotzyv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от  #полиглотиков.<br>
                    Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре в школу, а учитель английского заболела, а потом и мы все заболели. Начала я искать, где можно английский подтянуть. Все заведения по дополнительному образованию в городе закрыты из-за карантина. Наткнулась на #полиглотиков, там как раз была акция 2 недели бесплатного обучения с онлайн учителем по зуму. Решили попробовать, вроде, понравилось. Миша «ходит» в группу для младших школьников. Вначале слова учили по темам, сейчас грамматика пошла. Втянулся, раньше спрашивал, когда занятия, сейчас сам уже всё расписание выучил, лучше меня знает. В школе тоже пятёрки «пошли» по английскому.<br>
                    Среднего из садика тоже на карантин «высадили», кружки все на дистанционном обучении, только задания присылают. А когда с ним все занятия выполнять… Хотелось, чтобы сам иногда занимался. Решили с Максимом тоже английский начать учить. Записала его в группу для начинающих возраст 5-6 лет. И не пожалела. Сейчас, через 3 месяца уже отвечает на вопросы о себе, о семье может немного рассказать, цвета знает и счёт до 10. Хотя до этого вообще английский не учил. Нравится, как преподаватель с ними работает, слова наглядно на картинках плюс подписаны на английском идёт зрительное и слуховое запоминание. Песенку в начале каждого занятия поют, уже вся семья выучила) Игры разнообразные на закрепление слов. У Максима азарт такой во время игры, первый раз даже не поняла, почему он у меня там кричит во время занятия.<br>
                    Единственное, мне кажется, Максиму не хватает начальных знаний, типа изучение алфавита. И время не всегда удобное, у нас 2 часа разница с московским, занятия иногда в 9 вечера. На курсе 2 варианта занятия днём в 12-13 и вечером в 8-9 вечера. Когда сидим дома, занимаемся днём, когда в садик ходим, то вечером. Хотя что Миша, что Максим готовы на все занятия ходить… и днём и вечером.<br>
                    Программа, в которой проходят занятия простая. 6-летний сын сам разобрался, что где включать.<br>
                    Учителя замечательные, хвалят, подбадривают, стараются всем внимания уделить. В дневных группах мало народа, иногда 1-2 человека занимаются, получается индивидуальное занятие, в вечерних больше — по 6-8 в среднем. В общем, всем, кто хочет поднятуть ребёнка по английскому, или начать изучать очень советую онлайн-курс от #полиглотиков «OnlineTeacher».<br>
                    Ах, да, ещё кроме основных занятий есть дополнительные «Арт класс», «мьюзик класс» и «стори тайм», где дети мастерят, рисуют, поют песни и слушают истории. Занятия проходят легко и весело. Спасибо всем преподавателям школы #полиглотиков.</span>
                </div>
              </div>
            </div>
        </div>
        <Entry/>

    </div>
</template>
<script>

    import Entry from "./Entry";
    import TimetableStatic from "./TimetableStatic";
    import CourseStatic from "./CourseStatic";


    export default {
        components: {
            CourseStatic,
            TimetableStatic,
            Entry,
        },
        name: 'GermanforBeginners',

        data: function () {
            return {
                title: null,
            }
        },

        metaInfo() {
            return {
                title: 'Курс групповых онлайн-занятий по программе German for Beginners',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: '☝☝☝☝☝ German for Beginners. Немецкий для начинающих. Курс групповых онлайн-занятий по программе «German for Beginners» рассчитан на детей от 3 до 8 лет, не имеющих опыта изучения немецкого'
                    }
                ]
            }
        },

        mounted() {
        },

        methods: {}
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
<style lang="scss" scoped>
    .razuchim {
        background-image: url(~@/assets/hometeacher/images/razuchim.png);
        height: 458px;
        background-position: top;
        background-repeat: no-repeat;
        margin-top: -2px;
        margin-bottom: 40px;
    }

    .skill-wrapper {
        position: relative;
    }

    .skill-text {
        font-family: Manrope Bold;
        font-size: 18px;
        line-height: 18px;
        border: 3px solid;
        border-radius: 50%;
        position: absolute;
        text-align: center;
        padding-left: 20px;
        padding-right: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-line-pack: center;
        align-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .skill-text span {
        margin: auto 0;
    }

    .skill-text-1 {
      color: #b01ced;
      border-color: #b01ced;
      height: 180px;
      width: 180px;
      left: 153px;
      top: 44px;
    }

    .skill-text-2 {
      color: #00b4f1;
      border-color: #00b4f1;
      height: 120px;
      width: 120px;
      top: 185px;
      left: 328px;
    }

    .skill-text-3 {
      color: #00963f;
      border-color: #00963f;
      height: 150px;
      width: 150px;
      top: 284px;
      left: 167px;
    }

    .skill-text-4 {
      color: #33c416;
      border-color: #33c416;
      height: 150px;
      width: 150px;
      top: 1px;
      left: 598px;
    }

    .skill-text-5 {
      color: #fa8500;
      border-color: #fa8500;
      height: 120px;
      width: 120px;
      top: 198px;
      left: 628px;
    }

    .skill-text-6 {
      color: #0450c3;
      border-color: #0450c3;
      height: 180px;
      width: 180px;
      top: 78px;
      left: 748px;
    }

    .skill-text-7 {
      color: #ed1c24;
      border-color: #ed1c24;
      height: 150px;
      width: 150px;
      top: 300px;
      left: 713px;
    }

    .skill-text-8 {
      color: #ed1c24;
      border-color: #ed1c24;
      height: 150px;
      width: 150px;
      top: -5px;
      left: 329px;
    }

    .skill-text-9 {
      color: #00f;
      border-color: #00f;
      height: 100px;
      width: 100px;
      top: 337px;
      left: 352px;
    }

    .vidos {
        width: 100%;
        height: 623px;
    }

    .sertifikat {
        max-width: 160px;
    }

    .px18 {
        color: #000;
    }

    .land-t-h2 {
        font-size: 24px;
        color: #4f4d5c;
    }

    .centers-text {
        text-align: center;
    }

    .teacher-krug {
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 2px 5px 3px #0003;
    }

    .teacher-name {
        margin-top: 36px;
        margin-bottom: 15px;
    }

    .teacher-name a {
        font-family: Manrope Bold;
        font-size: 16px;
        color: #000000;
        text-decoration: underline;
    }

    .teacher-name a:hover {
        text-decoration: none;
        color: #5ab947;
    }

    .speach {
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 50px;
        color: #000;
    }

    .bird-pres {
        margin-top: 50px;
        min-height: 200px;
    }

    .bird-pres p {
        font-size: 18px;
        font-family: "Manrope Bold";
        padding-left: 110px;
        color: #000000;
    }

    .bird-pres img {
        float: left;
        margin-right: 10px;
        margin-bottom: 25px;
    }

    .knpk {
        border-radius: 7px;
        font-family: Manrope Bold;
        background: -webkit-gradient(linear, left bottom, left top, from(#058bca), to(#00bdfd));
        /*background: #00bcfb;*/
        font-size: 18px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0px 3px 3px #0003;
        text-decoration: none;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    }

    .knpk:hover {
        color: #fff;
        background: #058bca;
    }

    .dateotzyv, .nameotzyv, .textotzyv {
        color: #000;
    }


    @media screen and (max-width: 1199px) and (min-width: 1025px) {
      .skill-text-1 {
        left: 77px;
      }
      .skill-text-2 {
        left: 266px;
      }
      .skill-text-4 {
        left: 500px;
      }
      .skill-text-5 {
        left: 525px;
      }
      .skill-text-6 {
        left: 640px;
      }
      .skill-text-7 {
        left: 635px;
        top: 270px;
      }
      .skill-text-8 {
        height: 140px;
        width: 140px;
        left: 251px;
        top: 0px;
      }
      .skill-text-9 {
        left: 520px;
      }
    }

    @media (max-width: 1024px) {
      .skill-text-1 {
        left: 77px;
      }
      .skill-text-2 {
        left: 266px;
      }
      .skill-text-4 {
        left: 500px;
      }
      .skill-text-5 {
        left: 525px;
      }
      .skill-text-6 {
        left: 640px;
      }
      .skill-text-7 {
        left: 635px;
        top: 270px;
      }
      .skill-text-8 {
        height: 135px;
        width: 135px;
        left: 251px;
        top: 0px;
      }
      .skill-text-9 {
        left: 520px;
      }
      .vidos {
        height: 525px !important;
      }
    }

    @media (max-width: 991px) {
      .skill-text-1 {
        left: 10px;
        top: 0px;
        width: 140px;
        height: 140px;
      }
      .skill-text-2 {
        left: 155px;
        top: 0px;
      }
      .skill-text-3 {
        left: 375px;
        top: 0px;
      }
      .skill-text-4 {
        left: 485px;
        top: 110px;
      }
      .skill-text-5 {
        left: 30px;
        top: 140px;
      }
      .skill-text-6 {
        width: 150px;
        height: 150px;
        left: 375px;
        top: 220px;
      }
      .skill-text-7 {
        left: 50px;
        width: 120px;
        height: 120px;
      }
      .skill-text-8 {
        left: 500px;
        top: 300px;
      }
      .skill-text-9 {
        left: 165px;
        top: 185px;
      }
    }

    @media (max-width: 767px) {
      .razuchim {
        background: none;
        margin-bottom: 0px;
      }
      .skill-text-6 {
        left: 158px;
        top: 125px;
      }
      .skill-text-4 {
        width: 140px;
        height: 140px;
        left: 183px;
        top: 278px;
      }
      .skill-text-3 {
        left: 280px;
      }
      .skill-text-8 {
        left: 308px;
        top: 150px;
      }
      .skill-text-9 {
        left: 330px;
        top: 300px;
      }
    }



    @media (max-width: 400px) {/*
        .skill-text-1 {
            width: 120px;
            height: 120px;
            left: 15px !important;
        }
        .skill-text-2 {
            top: 108px !important;
        }
        .skill-text-3 {
            left: 19px !important;
            width: 130px;
            height: 130px;
        }
        .skill-text-4 {
            width: 125px;
            height: 125px;
            left: 243px !important;
        }
        .skill-text-5 {
            left: 240px !important;
        }
        .skill-text-6 {
            width: 120px;
            height: 120px;
            left: 243px !important;
        }
        .skill-text-7 {
            width: 130px;
            height: 130px;
            left: 140px !important;
        }
        .vidos {
            height: 214px !important;
        } */
      .skill-text-8 {
        top: 477px;
        left: 61px;      }
    }

    @media (max-width: 375px) {
        .vidos {
            height: 202px !important;
        }
    }

    @media (max-width: 320px) {
        .vidos {
            height: 180px;
        }
     /*   .skill-text-4 {
            left: 194px !important;
        }
        .skill-text-6 {
            left: 193px !important;
        }
        .skill-text-7 {
            left: 113px !important;
        }
        .skill-text-5 {
            left: 200px !important;
        }
        .skill-text-1, .skill-text-2, .skill-text-3 {
            left: 0px !important;
        }*/
    }





    @media (max-width: 575px) {
        .blue-wave-top, .blue-wave-bottom, .green-wave-bottom, .green-wave-top {
            background-size: auto;
        }
        .topchik h1 {
            margin-left: 15px;
        }
        .group {
            float: none;
            margin-left: 15px;
        }
        .prezent {
            text-align: center;
        }
        .prezent h2 {
            margin-left: 15px;
            margin-right: 15px;
            text-align: left;
        }
        .prezent h3 {
            margin-left: 15px;
            margin-right: 15px;
            text-align: left;
        }
        .prezent p {
            text-align: left;
        }
        .prezent img {
            float: none;
            margin-left: 15px;
            margin-top: 15px;
            margin-bottom: 30px;
        }
        .orange-knp {
            padding: 20px 30px;
        }
        .white-bg h2 {
            margin-left: 15px;
        }
        .nazan {
            margin-left: 0px;
        }
        .skill-wrapper img {
            width: 133px;
            margin-left: 0px;
            margin-top: 264px;
        }
        .urok {
            height: 755px;
        }
      .skill-text-6 {
        left: 158px;
        top: 125px;
      }
      .skill-text-4 {
        width: 140px;
        height: 140px;
        left: 183px;
        top: 278px;
      }
      .skill-text-3 {
        left: 280px;
      }
      .skill-text-8 {
        left: 308px;
        top: 150px;
      }
      .skill-text-9 {
        left: 330px;
        top: 300px;
      }
        .mbpt {
            padding-bottom: 10px !important;
        }
        .vidos {
            height: 311px;
            margin-left: 2px;
        }
        .speach {
            margin-left: 10px;
            margin-right: 10px;
        }
      .indivurok {margin: 10px 15px;}
    }

    @media (max-width: 481px) {
      .razuchim {
        height: 600px;
      }
      .skill-text-1 {
        width: 120px;
        height: 120px;
      }
      .skill-text-3 {
        left: 10px;
        top: 395px;
        width: 105px;
        height: 105px;
        padding-left: 5px;
      }
      .skill-text-7 {
        left: 10px;
      }
      .skill-text-4 {
        left: 140px;
      }
      .skill-text-8 {
        left: 285px;
        top: 4px;
        padding-left: 5px;
        width: 120px;
        height: 120px;
      }
      .skill-text-9 {
        left: 155px;
        top: 420px;
      }
      .vidos {
        height: 258px !important;
      }
    }

</style>
